import './DataRow.scss';

/**
 * DataRow component
 * @param {{
 *   labelLeft: string,
 *   dataLeft: import('react').ReactNode,
 *   labelRight?: string,
 *   dataRight?: import('react').ReactNode,
 *   fluid?: boolean,
 *   className?: string
 * }} props
 * @returns {JSX.Element} DataRow
 */
function DataRow({ labelLeft, dataLeft, labelRight, dataRight, fluid = false, className = '' }) {
  return (
    <div className={`data-row ${labelRight ? 'two-column' : ''} ${fluid ? 'fluid' : ''} ${className}`}>
      <div className="left-bx">
        <div className="label">{labelLeft}</div>
        <div className="data">{dataLeft}</div>
      </div>

      {labelRight && (
        <div className="right-bx">
          <div className="label">{labelRight}</div>
          <div className="data">{dataRight}</div>
        </div>
      )}
    </div>
  );
}

export default DataRow;
